exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tijiaoanniu[data-v-3c4cad3e]{width:130px;height:30px;background:#06f;border:none;color:#fff;border-radius:20px;margin-top:20px}.shuruyanz[data-v-3c4cad3e]{width:220px;height:40px}.yanzhengmade[data-v-3c4cad3e]{text-align:center;margin-top:20px}.anquan p[data-v-3c4cad3e]{color:#000;font-weight:600}.anquan[data-v-3c4cad3e]{text-align:center}.guanbi[data-v-3c4cad3e]{text-align:right}.yanzhengma[data-v-3c4cad3e]{height:230px}.chakang[data-v-3c4cad3e]{text-align:center;color:#000;margin-top:20px}.baozheng[data-v-3c4cad3e]{text-align:center;color:#a9a9a9;margin-top:20px}.quyanz[data-v-3c4cad3e]{width:240px;height:40px;background:#32cd32;margin:0 auto;border-radius:20px;margin-top:20px;text-align:center;line-height:40px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3c4cad3e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/menu/naturalendowments/Companyinformation.vue
// module id = 548
// module chunks = 0